import { FC, type HTMLAttributeAnchorTarget } from 'react';

// ========================= 组件 =========================
import IconFont from '@/components/iconfont';
import { Typography } from 'antd';
const { Title } = Typography;

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================

// ========================= 样式 =========================
import styles from './index.module.css'
import Link from '../link';
import { useRouter } from 'next/router';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface SwiperArticleItemProps {
    video?: boolean;
    image: string;
    title?: string;
    id: number;
    index?: number;
    href?: string;
    target?: HTMLAttributeAnchorTarget;
    onClick?: (id: number, index?: number) => void;
}

const SwiperArticleItem: FC<SwiperArticleItemProps> = ({ video = false, target, index, id, href, image, title, onClick }) => {

    const { locale = 'zh' } = useRouter();

    const ItemContext = (
        <div
            className={styles['item']}
            onClick={() => {
                onClick && onClick(id, index)
            }}
        >
            <div className={styles['item-image-wrapper']}>
                <img className={styles['image']} src={image || ''} alt="" />
                {
                    video && [
                        <IconFont type="icon-bofang" className={styles['item-icon']} />,
                        <div className={styles['item-mask']} />
                    ]
                }
            </div>
            <div className={styles['item-content']}>
                <Title className={styles['title']} ellipsis={{ rows: 2, expandable: true, symbol: false }}>{title}</Title>
            </div>
        </div>

    )

    return (
        href ? (
            <Link className={styles['link']} href={href} target={target} locale={locale}>
                {ItemContext}
            </Link>
        ) : ItemContext
    );
}
export default SwiperArticleItem;